module.exports = __webpack_public_path__ + "img/jnhb_s.1e1497f.png";